import type { SlotType } from '../../types/slot';
import type { BlockComponentType, BlockComponentStateId, BlockId } from '../../types/block';
import type { StyleObject } from '../../types/styleObject';

type MappedValue = {
  key: string;
  path: string;
  originalPath: string;
  originalKey: string;
};

export enum Modes {
  Mapped = 'mapped',
  Entity = 'entity',
}

export type MappedItems = {
  mode: Modes.Mapped;
  events: {
    data: string;
    mappings?: {
      id?: MappedValue;
      title?: MappedValue;
      start?: MappedValue;
      end?: MappedValue;
      allDay?: MappedValue;
    };
  };
};

export type CalendarEvent = {
  id: string;
  title: string;
  start?: string | number;
  end?: string | number;
  allDay: boolean;
};

export type EntityRecords = {
  mode: Modes.Entity;
  entities: string[];
  events?: {
    data?: string;
  };
};

export type Content = {
  defaultDate?: string;
  blockId?: BlockId;
  defaultView?: string;
} & (MappedItems | EntityRecords);

export type Appearance = {
  styles?: Pick<
    StyleObject,
    | 'padding'
    | 'margin'
    | 'height'
    | 'minHeight'
    | 'maxHeight'
    | 'width'
    | 'minWidth'
    | 'maxWidth'
    | 'borderColor'
    | 'borderWidth'
    | 'borderRadius'
    | 'backgroundColor'
    | 'visibility'
  >;
};

export type Slots = {
  event?: SlotType;
};

export type CalendarComponentType = BlockComponentType<
  'EventsCalendar',
  Content,
  Appearance,
  Slots
>;

export type CalendarBlockStateType = Pick<
  CalendarComponentType,
  'content' | 'componentType' | 'appearance'
> &
  BlockComponentStateId & {
    currentView?: {
      type: string;
      start: Date;
      end: Date;
      title: string;
    };
    selectedInterval?: { start?: Date; end?: Date; allDay?: boolean };
    selectedItem?: {
      id: string;
      title: string;
      start: Date | null;
      end: Date | null;
      allDay: boolean;
      recurrence?: string;
      userIds?: string[];
      notify?: string;
      location?: string;
      description?: string;
    };
  };

export type CalendarBlockRef = {
  refetch?: () => Promise<unknown>;
  unselectInterval?: () => void;
};

export enum ToolbarAlignmentTypeEnum {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum ToolbarActionTypeEnum {
  SWITCH_VIEW = 'SWITCH_VIEW',
  NAVIGATION_BUTTONS = 'NAVIGATION_BUTTONS',
  TITLE = 'TITLE',
}

export type StandardActionItem = {
  id: ToolbarActionTypeEnum;
  alignment: ToolbarAlignmentTypeEnum;
};
